import swal from "sweetalert";
import axiosInstance from "../api";
import { setAllUserTicketList, setgetsingleUserTicket} from "../reusable/reusableSlice";

export const getAllUsersTicketsListData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`/user/user_ticket_list`,data);
      if (response?.data) {
        dispatch(setAllUserTicketList(response?.data?.response))
        return response
      } else {
        dispatch(setAllUserTicketList([]))
      }
      return response
    } catch (err) {
      dispatch(setAllUserTicketList([]))
    }
  };

  export const getSingleUserTicketById = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/user/get_by_id_user_ticket/${id}`);
      if (response?.data) {
        dispatch(setgetsingleUserTicket(response?.data?.response))
      } else {
        dispatch(setgetsingleUserTicket([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setgetsingleUserTicket([]))
    }
  };

  export const updateUserOneTicket = (data, setLoading) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("/user/update_user_ticket", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        // dispatch(getSingleUserTicketById(data.id))
        dispatch(getAllUsersTicketsListData({
            search_key: "",
            page: 1,
          }))
        return response
      }
      else {
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };